export const workOrderTypes = {
    维修: 'f533e7f0-be81-41ee-88a0-87e3e59014f5',
    保养: '9c80d8cc-fe38-4bff-bb0e-99817239d9ba'
};